import { cssClass } from '@tableau/data-catalog-shared';
import { TabStyles } from '@tableau/widgets';
import * as React from 'react';
import { Messages } from '../../../gen-src/Localize';
import { SvgWarning } from '../../../gen-src/icons/Warning';

const borderRadiusValue = '4px';

const warningStyle = cssClass('parametersWarningBanner', {
  display: 'flex',
  padding: TabStyles.Spacing.MediumSpace,
  borderRadius: `${borderRadiusValue} 0 0 ${borderRadiusValue}`,
  backgroundColor: '#fef9ef',
  borderLeft: `4px solid #feca63`,
  margin: `${TabStyles.Spacing.LargeSpace}px ${TabStyles.Spacing.MediumSpace}px 0 ${TabStyles.Spacing.MediumSpace}px `
});

const message = cssClass('parameterWarningMessage', {
  paddingLeft: TabStyles.Spacing.SmallSpace,
})

export function FlowParametersWarning(): JSX.Element {
  return (
    <div className={warningStyle}>
      <SvgWarning />
      <div className={message}>{Messages.FlowParametersLineageWarning()}</div>
    </div>
  )
}
